import { createSelector } from 'reselect'

export const selectCart = state => state.get('cart');
export const selectCartCount = createSelector(selectCart, cart => cart.get('cartCount'));
export const selectCartSuccess = createSelector(selectCart, cart => cart.get('cartSuccess'));
export const cartLoading = createSelector(selectCart, cart => cart.get('loading'));
